// Others
import { urlApiAuth } from '~/utils/constants/apis';
import axiosClient from './axiosClient';
import { IBodyNewPassword, IFormForgotPassword, IFormLogin, IResponseLogin } from '~/utils/interface/auth';
import { IBaseResponse } from '~/utils/interface/base';
import { IBodyResendCode, IBodyVerifyCode } from '~/utils/interface/verifyCode';

const authApi = {
  login(payload: IFormLogin) {
    const url = `${urlApiAuth.login}`;
    return axiosClient.post<IBaseResponse<IResponseLogin>>(url, payload);
  },

  verifyCode(body: IBodyVerifyCode) {
    const url = `${urlApiAuth.verifyCode}`;
    return axiosClient.post<IBaseResponse>(url, body);
  },

  resendCode(body: IBodyResendCode) {
    const url = `${urlApiAuth.resendCode}`;
    return axiosClient.post<IBaseResponse>(url, body);
  },

  forgotPassword(body: IFormForgotPassword) {
    const url = urlApiAuth.forgotPassword;
    return axiosClient.post<IBaseResponse>(url, body);
  },

  createNewPassword(body: IBodyNewPassword) {
    const url = urlApiAuth.createNewPassword;
    return axiosClient.post<IBaseResponse>(url, body);
  },
};

export default authApi;
